import { Logger } from './logger';

export const MESSAGE_EVENT = {
  SIGNUP: 'signup',
  LOGIN: 'login',
  LOGOUT: 'logout',
  ACSB_USER_LOADED: 'acsb-user-loaded',
  DOMAIN_LIST: 'domain-list',
  LICENSE_TRIAL: 'license-trial',
  IFRAME_READY: 'iframe-ready',
  ADD_SCRIPT: 'add-script',
  REMOVE_SCRIPT: 'remove-script',
  MODIFY_CONFIG: 'modify-config',
  REDIRECT_TO_URL: 'redirect-to-url',
  REMOVE_QUERY_PARAM: 'remove-query-param',
  CREATE_DOMAIN_OWNERSHIP_REQUEST: 'create-domain-ownership-request',
};

type MessageEventType = (typeof MESSAGE_EVENT)[keyof typeof MESSAGE_EVENT];

export const sendMessageToWrapper = (
  eventName: MessageEventType,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: any = {},
) => {
  Logger.log('Sending message to wrapper', { eventName });
  window.parent.postMessage({ eventName, data }, '*');
};
